"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgPenFilled = function SvgPenFilled(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M17 2.74c.948-.94 1.892-.939 2.832.003 1.41 1.412-.002-.004 1.411 1.411.943.944.943 1.886 0 2.829L18.415 9.81l-4.243-4.243 2.829-2.828zm-4.07 4.07l4.243 4.243L7.1 21.124l-3.844.78a1.166 1.166 0 0 1-.89-.197c-.268-.186-.373-.517-.315-.994l.807-3.831L12.929 6.81z'
  }));
};

exports.default = SvgPenFilled;